import React, { memo, useMemo } from "react";
import { Card, Label, Image, Icon } from "semantic-ui-react";
import IObservation from "../../interfaces/IObservation";
import { PersonName } from "../person/PersonName";
import { FormTypeName } from "../formType/FormTypeName";
import { StatusColors } from "../../constants/statusColors";
import { useFormTypeById } from "../../store/selectors/formSelectors";
import { FormCategoryIcon } from "../formType/FormCategoryIcon";
import { formatIdLabel, getReadableTimestamp } from "../../utils/havainnot.helper";
import { useApplicationConfiguration } from "../../configuration/ConfigurationContext";
import { useTranslation } from "react-i18next";
import { HavainnotRouteId } from "../../../routes";
import { Link } from "react-router-dom";
import { getRouteHrefById } from "../../../../routing";
import { Thumbnail } from "../../../../sg-fileupload";
import { useUserCanViewNames } from "../../store/selectors/appRoleSelector";

interface IWorkListItemProps {
    item: IObservation;
    showCreator: boolean;
    showId: boolean;
}

const WorkListItem: React.FC<IWorkListItemProps> = ({ item, showCreator = true, showId = false }) => {
    const { t } = useTranslation();
    const { components: { LocationName } } = useApplicationConfiguration();
    const formType = useFormTypeById(item.formType);
    const showNameDetail = useUserCanViewNames(formType?.category);

    const routeLinkParam = useMemo(() => ({ observation: item.guid, }), [item]);
    const labelColor = StatusColors[item.status];

    return (
        <Card as={Link} to={getRouteHrefById(HavainnotRouteId.ObservationPage, routeLinkParam)} params={routeLinkParam} className="havainto-card" fluid>
            <Card.Content>
                <Label attached="top left" color={labelColor}>
                    {formType?.category && <FormCategoryIcon categoryId={formType.category} />}
                    <FormTypeName formTypeId={item.formType} />
                    {showId && <span style={{ fontWeight: "lighter" }}>{"  "} {formatIdLabel(item.id)}</span>}
                </Label>

                <div className="havainto-content">

                    <div className="text-content">

                        <h4 className="ui header">{item.name}</h4>

                        <div className="havaintocontent-meta">
                            {item.target ? <div className="meta-item" title={t("Ilmoittaja")}><Icon name="marker" /><LocationName locationId={item.target} /></div> : null}
                            {showCreator && showNameDetail ? <div className="meta-item"><Icon name="user" /><PersonName personId={item.creator} /></div> : null}
                            <div className="meta-item" title={t("Luotu")}><Icon name="calendar" /> {getReadableTimestamp(item.created_at)} </div>
                            {showCreator && item.editor ? <div className="meta-item" title={t("Käsittelijä")}><Icon name="edit" /><PersonName personId={item.editor} /></div> : null}
                        </div>
                    </div>

                    {item.image ? (
                        <Image.Group size="tiny" className="rounded floated right" >
                            <div className="image" style={{ minHeight: "60px", backgroundImage: `url(${process.env.PUBLIC_URL}/loading_placeholder.gif)` }}>
                                <Thumbnail id={item.image} style={{ margin: 0 }} thumbnailWidth={60} />
                            </div>
                        </Image.Group>
                    ) : null}
                </div>
            </Card.Content>
        </Card>
    );
};

export default memo(WorkListItem);
